import type { IconData } from '@stacksjs/iconify-core'

export const mediaPlay: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M444.4 235.236L132.275 49.449A24 24 0 0 0 96 70.072v364.142a24.017 24.017 0 0 0 35.907 20.839L444.03 276.7a24 24 0 0 0 .367-41.461ZM128 420.429V84.144l288.244 171.574Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mediaPlay
